import NameForm from "@/features/profile/components/NameForm";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import { OnboardingPatientPage } from "@/features/onboarding/components/OnboardingPatientPage";
import { useNavigateToNextOnboardingRoute } from "../../features/onboarding/hooks/useNavigateToNextOnboardingRoute";
import type { ProfileT } from "@patient-watch/types/database";
import { useAuth } from "@/utils/auth";
import { createFileRoute } from "@tanstack/react-router";

const Name = () => {
    const auth = useAuth();
    const { profile } = Route.useLoaderData();

    const nextPage = useNavigateToNextOnboardingRoute("/onboarding/name");

    return (
        <OnboardingPatientPage step="name">
            <NameForm
                userId={auth.id}
                title={(profile?.title as "Mr" | "Mrs" | "Ms" | "Miss" | "Dr" | "Prof" | null) ?? null}
                firstName={profile?.first_name ?? ""}
                lastName={profile?.last_name ?? ""}
                autoFocus={true}
                onSuccess={nextPage}
                isDialog={false}
            />
        </OnboardingPatientPage>
    );
};
export const Route = createFileRoute("/onboarding/name")({
    component: Name,
    loader: async ({ context }) => {
        let profile: ProfileT | null = null;
        if (context?.auth?.id) {
            profile = await context?.queryClient.ensureQueryData(selectProfileByIdQueryOptions(context.auth.id));
        }
        return { profile };
    },
});
